import { useTranslation } from 'src/hooks';
import { TableColumnKey } from '../types/Table';

const useErrorMsgTranslate = () => {
  const { t, tc, translate } = useTranslation('clientCreditAllocation');

  const getErrorMsgTranslate = (msg?: string | null): string => {
    if (!msg) {
      return '';
    }
    switch (msg) {
      //pfh no error
      case "Paramter invalid - 'Customer No.' does not exist":
        return t('pfh_no_not_found');
      case 'Customer No. does not exist':
        return t('pfh_no_not_found');
      case "Paramter invalid - There is still pending application for the 'Customer No.'":
        return t('pendingApplicationError');
      case "Paramter invalid - 'Customer No.' is not belong to 'PA Id'":
        return translate('validation.isInValid', { fieldName: t(TableColumnKey.pfhNo) });

      //credit currency error
      case "Paramter invalid - 'Credit Currency' is invalid":
        return translate('validation.isInValid', { fieldName: t(TableColumnKey.CreditCurrency) });

      //credit amount error
      case 'Must be positive number - creditAmount':
        return translate('validation.isInValid', { fieldName: t(TableColumnKey.CreditAmount) });
      case "Paramter invalid - 'Credit Amount' exceeds two decimal places":
        return t('twoDecimalPlacesError');
      default:
        return msg;
    }
  };

  return { getErrorMsgTranslate };
};
export default useErrorMsgTranslate;
